import { groupBy } from 'lodash'
import { defineStore } from 'pinia'

import { Download } from '@/common/models/data/dashboard/downloads/download'
import DownloadsRepository from '@/app/repositories/downloads-repository'

const useDownloadsStore = defineStore('downloads', {
    state: () => ({
        entries: [] as Array<Download>
    }),
    actions: {
        async load (): Promise<void> {
            this.entries = await DownloadsRepository.all()
        }
    },
    getters: {
        groupedEntries: (state): Record<string, Array<Download>> => {
            return groupBy(state.entries, entry => entry.category.category)
        }
    }
})

export {
    useDownloadsStore
}
